// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TV1A","left":"styles_left__35ZGc"};